<form [formGroup]="form">
  <div class="pb-lg gap-lg flex flex-col">
    <div hlmField>
      <label for="indice" hlmFieldLabel labelRequired>Nom de l'indice</label>
      <input id="incide" hlmInput formControlName="nom" />
      @if (nom.hasError('required') && nom.touched) {
        <hlm-field-error>Merci de renseigner un nom</hlm-field-error>
      }
      @if (nom.hasError('notUnique')) {
        <hlm-field-error>Cet indice de résultats existe déjà</hlm-field-error>
      }
    </div>

    <div hlmField>
      <label for="select-aptitude" hlmFieldLabel>Rattaché à</label>
      <hlm-select id="'select-aptitude" formControlName="aptitude">
        <hlm-select-trigger>
          <hlm-select-value />
        </hlm-select-trigger>

        <hlm-select-content>
          <hlm-input-group class="border-grey-3 text-grey-7">
            <input
              class="round-l-md"
              formControlName="nomAptitude"
              placeholder="Rechercher par nom d'aptitude"
              type="text"
              hlmInputGroupInput
            />
            <hlm-input-group-addon align="inline-end">
              <ng-icon hlm name="lucideSearch" />
            </hlm-input-group-addon>
          </hlm-input-group>

          @for (group of aptitudesFiltrees(); track $index) {
            <hlm-select-group>
              <hlm-select-label>{{ group.nom }}</hlm-select-label>
              @for (aptitude of group.items; track aptitude.id) {
                <hlm-option [value]="aptitude.id">
                  {{ aptitude.nom }}
                </hlm-option>
              }
            </hlm-select-group>
          }
        </hlm-select-content>
      </hlm-select>
    </div>
  </div>
</form>
